import { BaseShareActionArgs, buildShareButtonComponent } from './base'
import { TelegramIcon } from '../../assets/icons'
import { encodeShareURL } from '../../helpers/sharing_helper'

export const telegramShareAction = ({ shareUrl, teaser = '', utmParams }: BaseShareActionArgs) =>
  window.open(
    `https://telegram.me/share/url?url=${encodeShareURL(shareUrl, utmParams)}&text=${encodeURIComponent(teaser)}`
  )

export const TelegramButton = buildShareButtonComponent({
  action: telegramShareAction,
  ariaLabel: 'Telegram',
  className: 'share-button--telegram',
  icon: TelegramIcon,
})

export type TelegramButtonProps = Parameters<typeof TelegramButton>['0']
